export type QualityTier = 'low' | 'mid' | 'high';

export interface Quality {
  readonly tier: QualityTier;
  readonly dprCap: number;
  readonly particleScale: number;
  /** Force a tier (or pass null to clear). */
  setOverride(tier: QualityTier | null): void;
}

interface NavigatorWithHints extends Navigator {
  deviceMemory?: number;
}

function scoreDevice(): number {
  const nav = navigator as NavigatorWithHints;
  const cores = nav.hardwareConcurrency ?? 4;
  const ram = nav.deviceMemory ?? 4;
  // Simple weighted score; tunable.
  return cores * 1.5 + ram * 2;
}

function tierFromScore(score: number): QualityTier {
  if (score >= 24) return 'high';
  if (score >= 12) return 'mid';
  return 'low';
}

const TIER_SETTINGS: Record<QualityTier, { dprCap: number; particleScale: number }> = {
  low: { dprCap: 1.0, particleScale: 0.3 },
  mid: { dprCap: 1.5, particleScale: 0.7 },
  high: { dprCap: 2.0, particleScale: 1.0 },
};

export function detectQuality(): Quality {
  const detected = tierFromScore(scoreDevice());
  let override: QualityTier | null = null;

  return {
    get tier(): QualityTier {
      return override ?? detected;
    },
    get dprCap(): number {
      return TIER_SETTINGS[this.tier].dprCap;
    },
    get particleScale(): number {
      return TIER_SETTINGS[this.tier].particleScale;
    },
    setOverride(t) {
      override = t;
    },
  };
}
